import { render } from "./header.vue?vue&type=template&id=3abd7e18&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3abd7e18"

export default script